import { createNextTableContext } from '@core/table';

export const CurrenciesTableContext = createNextTableContext();
